import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import * as selectors from "domain/core/selector";
import { useActions, useReduxState } from "re-reduced";
import CircularProgress from "@material-ui/core/CircularProgress";
import UnAuthenticatedHome from "./Home/UnAuthenticatedHome";
import AuthenticatedHome from "./Home/AuthenticatedHome";
import AuthActions from "domain/core/auth/actions";
const Main = () => {
  const actions = useActions(AuthActions);
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const state = useReduxState({ ...selectors });

  useEffect(() => {
    if (isAuthenticated && !state.getIsAuthenticated) {
      const fetchAccessToken = async () => {
        try {
          const accessToken = await getAccessTokenSilently();
          actions.login2({ token: accessToken! });
        } catch (e) {
          console.error(e);
        }
      };
      fetchAccessToken();
    }
  }, [
    isAuthenticated,
    getAccessTokenSilently,
    state.getIsAuthenticated,
    actions,
  ]);
  if (isLoading) {
    return <CircularProgress />;
  }
  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <div>
      {!state.getIsAuthenticated && <UnAuthenticatedHome />}

      {state.getIsAuthenticated && <AuthenticatedHome />}
    </div>
  );
};

export default Main;
